import React from 'react';

import cx from 'classnames';

import Icon from 'components/shared/Icon';
import ArrowTopMini from 'components/shared/Icon/icons/ArrowTopMini';
import EnterIcon from 'components/shared/Icon/icons/EnterIcon';

import styles from './index.module.css';

const ACTION_TYPES = {
  NAVIGATE: 'NAVIGATE',
  SELECT: 'SELECT',
  ESCAPE: 'ESCAPE',
};
const DEFAULT_ACTIONS = [ACTION_TYPES.NAVIGATE, ACTION_TYPES.SELECT, ACTION_TYPES.ESCAPE];

function MenuActionsHelper({ actions = DEFAULT_ACTIONS, escOnly, center, isNew }) {
  let resultActions = actions;
  if (escOnly) {
    resultActions = [ACTION_TYPES.ESCAPE];
  }

  return (
    <div className={cx(styles.footer, center && styles.footerCenter, isNew && styles.newFooter)}>
      {resultActions.map((action) => {
        if (action === ACTION_TYPES.NAVIGATE) {
          return (
            <div key={action} className={cx(styles.footerItem, isNew && styles.newFooterItem)}>
              <Icon component={ArrowTopMini} width="14px" height="19px" />
              <div className={styles.footerLabel}>to navigate</div>
            </div>
          );
        }

        if (action === ACTION_TYPES.SELECT) {
          return (
            <div key={action} className={cx(styles.footerItem, isNew && styles.newFooterItem)}>
              <Icon
                component={EnterIcon}
                stroke="#212121"
                className={cx(styles.iconNav, styles.enter)}
                width="14px"
                height="19px"
              />
              <div className={styles.footerLabel}>to select</div>
            </div>
          );
        }

        if (action === ACTION_TYPES.ESCAPE) {
          return (
            <div key={action} className={cx(styles.footerItem, isNew && styles.newFooterItem)}>
              <b>esc</b>
              <div className={styles.footerLabel}>to dismiss</div>
            </div>
          );
        }

        return null;
      })}
    </div>
  );
}

MenuActionsHelper.ACTION_TYPES = ACTION_TYPES;
export default MenuActionsHelper;
